// Shared map configuration: categories, highway shields, city labels

export const CATEGORY_META = {
  chiropractic: { label: "Chiropractic", color: "#1D4ED8" },
  pain_management: { label: "Pain Management", color: "#F97316" },
  diagnostic_imaging: { label: "Diagnostic Imaging", color: "#22C55E" },
  neurology_tbi: { label: "Neurology / TBI", color: "#7C3AED" },
  telemed: { label: "Telemed MD Consult", color: "#0D9488" },
  other_services: { label: "Other Services", color: "#64748B" },
  pharmacy: { label: "Pharmacy", color: "#312E81" },
};

export const DFW_CENTER = [-96.95, 32.92];
export const DFW_ZOOM = 9.1;

// Free CARTO Positron vector style (no token required) — light-toned base
export const MAP_STYLE = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";

// Basemap options — all free, no token required
export const MAP_STYLES = {
  light: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
  streets: "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json",
  satellite: {
    version: 8,
    sources: {
      "esri-imagery": {
        type: "raster",
        tiles: [
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        ],
        tileSize: 256,
        attribution: "Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics",
      },
      "esri-labels": {
        type: "raster",
        tiles: [
          "https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
        ],
        tileSize: 256,
      },
    },
    layers: [
      { id: "esri-imagery", type: "raster", source: "esri-imagery" },
      { id: "esri-labels", type: "raster", source: "esri-labels" },
    ],
  },
};

export const BASEMAP_OPTIONS = [
  { key: "light", label: "Light" },
  { key: "streets", label: "Streets" },
  { key: "satellite", label: "Satellite" },
];

export const US_BOUNDS = [
  [-125.0, 24.0],
  [-66.5, 49.6],
];

export const HIGHWAY_SHIELDS = [
  { label: "I-35E", type: "interstate", lng: -96.99, lat: 33.05 },
  { label: "I-35W", type: "interstate", lng: -97.32, lat: 32.86 },
  { label: "I-635", type: "interstate", lng: -96.77, lat: 32.925 },
  { label: "I-30", type: "interstate", lng: -96.56, lat: 32.79 },
  { label: "I-20", type: "interstate", lng: -96.83, lat: 32.655 },
  { label: "I-45", type: "interstate", lng: -96.62, lat: 32.55 },
  { label: "I-820", type: "interstate", lng: -97.31, lat: 32.74 },
  { label: "US-75", type: "us", lng: -96.7, lat: 33.06 },
  { label: "US-380", type: "us", lng: -96.72, lat: 33.235 },
  { label: "US-287", type: "us", lng: -97.3, lat: 32.69 },
  { label: "183", type: "state", lng: -97.06, lat: 32.84 },
  { label: "114", type: "state", lng: -97.16, lat: 32.95 },
  { label: "121", type: "state", lng: -96.88, lat: 33.09 },
  { label: "161", type: "state", lng: -96.99, lat: 32.8 },
  { label: "360", type: "state", lng: -97.05, lat: 32.71 },
];

export const CITY_LABELS = [
  { name: "Dallas", lng: -96.797, lat: 32.7767 },
  { name: "Fort Worth", lng: -97.33, lat: 32.7555 },
  { name: "Arlington", lng: -97.108, lat: 32.7357 },
  { name: "Plano", lng: -96.6989, lat: 33.0198 },
  { name: "Frisco", lng: -96.8236, lat: 33.1507 },
  { name: "McKinney", lng: -96.6398, lat: 33.1972 },
  { name: "Irving", lng: -96.9489, lat: 32.814 },
  { name: "Garland", lng: -96.6389, lat: 32.9126 },
  { name: "Mesquite", lng: -96.5992, lat: 32.7668 },
  { name: "Denton", lng: -97.133, lat: 33.2148 },
  { name: "Grapevine", lng: -97.078, lat: 32.9343 },
  { name: "Richardson", lng: -96.7297, lat: 32.9483 },
  { name: "Allen", lng: -96.6705, lat: 33.1032 },
  { name: "Flower Mound", lng: -97.097, lat: 33.0146 },
  { name: "Southlake", lng: -97.134, lat: 32.9412 },
];
